// extracted by mini-css-extract-plugin
export default {"root":"NavItemUser_root__RzPEx","avatar":"NavItemUser_avatar__OwvwV"};